// Spanish (es). Keyed by the English source string.
//
// NOT YET REVIEWED by a Spanish speaker -- see locales/index.js. Load it with
// ?lang=es to read it in place; it is not offered to users until reviewed.
//
// Notes for whoever reviews it: "Denunciar" is used for reporting a person to
// moderation (not "informar", which reads as filing a note). Second person
// singular "tu" throughout -- Lumi is a place for talking to strangers
// casually, and "usted" would sound like a bank. Where English says "tap",
// Spanish says "toca", which works for both a tap and a click.
export default {
  // ---- Landing ----
  'Light up a conversation': 'Enciende una conversación',
  'Free, anonymous video, audio and text chat. Meet someone new one to one, or open a room and bring your friends.':
    'Chat gratuito y anónimo por vídeo, voz y texto. Conoce a alguien nuevo cara a cara, o abre una sala e invita a tus amigos.',
  'Name (optional)': 'Nombre (opcional)',
  'Optional: what should people call you?': 'Opcional: ¿cómo quieres que te llamen?',
  'Interests (optional)': 'Intereses (opcional)',
  'Optional: interests (e.g. music, hiking, anime)': 'Opcional: intereses (p. ej. música, senderismo, anime)',
  'Your age is never shown to anyone. It sets which age group you chat in, not who you meet in it.':
    'Tu edad nunca se muestra a nadie. Define en que grupo de edad chateas, no a quien conoces dentro de el.',
  'Birth year': 'Año de nacimiento',
  'Select year': 'Elige el año',
  'How do you want to chat?': '¿Cómo quieres hablar?',
  Camera: 'Cámara',
  'Ready to Chat': 'Listo para hablar',
  'Group rooms': 'Salas de grupo',
  'Ten minutes': 'Diez minutos',
  'A chat with a gentle end, with people who chose it too.':
    'Una conversación con un final tranquilo, con gente que también lo eligió.',
  About: 'Acerca de',
  Regulars: 'Habituales',
  'Your regulars': 'Tus habituales',
  'Watch together': 'Ver juntos',
  'You are invited to a group room': 'Te han invitado a una sala de grupo',
  'You are invited to a community.': 'Te han invitado a una comunidad.',
  ' Verify your age to ask to join. Its host lets people in when they see the request.':
    ' Verifica tu edad para pedir entrar. El anfitrión admite a la gente cuando ve la solicitud.',

  // ---- Chat ----
  Chat: 'Chat',
  'Say something nice...': 'Di algo agradable...',
  'Finding someone new...': 'Buscando a alguien nuevo...',
  'Show my camera': 'Mostrar mi cámara',
  'Cameras open when you both tap Show my camera':
    'Las cámaras se abren cuando los dos tocáis Mostrar mi cámara',
  'Open your camera to them. It opens once they have done the same.':
    'Abre tu cámara para esa persona. Se abrirá cuando haga lo mismo.',
  'Skip to the next person': 'Pasar a la siguiente persona',
  'Leave the chat and go back to the homepage': 'Salir del chat y volver a la página de inicio',
  'Report this person': 'Denunciar a esta persona',
  Report: 'Denunciar',
  Wave: 'Saludar',
  'Wave at the person you just talked to': 'Saluda a la persona con la que acabas de hablar',
  'Go back to that person': 'Volver con esa persona',
  'Send an image': 'Enviar una imagen',
  'Share a photo, video, or audio file': 'Comparte una foto, un vídeo o un archivo de audio',
  'Report this file to the Lumi team': 'Denunciar este archivo al equipo de Lumi',
  Remove: 'Eliminar',
  'Remove this person for 15 minutes (moderator)': 'Expulsar a esta persona 15 minutos (moderador)',
  'You removed this.': 'Has eliminado esto.',
  'Take this off your screen': 'Quitar esto de tu pantalla',
  'Cancel reply': 'Cancelar respuesta',
  'A question, if you want one: ': 'Una pregunta, si te apetece: ',
  'Dismiss this question': 'Descartar esta pregunta',
  'Double-tap to show the chat and controls': 'Toca dos veces para mostrar el chat y los controles',
  'Not now': 'Ahora no',
  'Lumi Staff': 'Equipo de Lumi',
  'LUMI STAFF': 'EQUIPO DE LUMI',
  'Verified Lumi staff': 'Equipo de Lumi verificado',
  Moderator: 'Moderador',
  'Verified moderator': 'Moderador verificado',
  'Lumi Plus member': 'Miembro de Lumi Plus',
  'Explicit: off': 'Explícito: desactivado',
  'Explicit chat (18+)': 'Chat explícito (+18)',
  'Match me only with adults who chose this too. It changes who you meet next, not this chat, and you both still have to agree once you are in one.':
    'Emparéjame solo con adultos que también lo hayan elegido. Cambia a quién conocerás después, no esta conversación, y aun así los dos tenéis que aceptarlo cuando estéis en una.',

  // ---- Rooms and communities ----
  ' here': ' aquí',
  '<- Back': '<- Atrás',
  'A community': 'Una comunidad',
  'A community is one private room somebody keeps for people they have invited. Lumi stores who is in it and the sessions planned, nothing else.':
    'Una comunidad es una sala privada que alguien mantiene para las personas que ha invitado. Lumi guarda quién está dentro y las sesiones previstas, nada más.',
  'A community: a private room its host keeps open for invited members':
    'Una comunidad: una sala privada que su anfitrión mantiene abierta para los miembros invitados',
  'A shared timer everyone in the room can see': 'Un temporizador compartido que ve toda la sala',
  Accept: 'Aceptar',
  Activities: 'Actividades',
  'Add session': 'Añadir sesión',
  'Add to calendar': 'Añadir al calendario',
  'Always open': 'Siempre abierta',
  'Anyone with the link can verify their age and ask to join. You decide who gets in.':
    'Cualquiera con el enlace puede verificar su edad y pedir entrar. Tú decides quién pasa.',
  'Ask one person who is waiting if they would like to join for ten minutes':
    'Pregunta a una persona que está esperando si quiere unirse diez minutos',
  'Ask to chat one-on-one': 'Pedir hablar cara a cara',
  'Asked to join': 'Ha pedido entrar',
  'Audio room': 'Sala de voz',
  Browse: 'Explorar',
  Close: 'Cerrar',
  'Communities you are in': 'Comunidades a las que perteneces',
  Community: 'Comunidad',
  'Copy Lumi Link': 'Copiar Lumi Link',
  'Copy my Lumi Link': 'Copiar mi Lumi Link',
  'Copy the Lumi Link for this room': 'Copia el Lumi Link de esta sala',
  Create: 'Crear',
  'Create one and it will show up here for everyone in your age group.':
    'Crea una y aparecerá aquí para todos los de tu grupo de edad.',
  'Create room': 'Crear sala',
  Decline: 'Rechazar',
  Delete: 'Eliminar',
  'Download an .ics file for this session': 'Descargar un archivo .ics de esta sesión',
  'Drop in': 'Entrar un momento',
  'Every live room': 'Todas las salas activas',
  'Every week': 'Cada semana',
  Generate: 'Generar',
  'Go 1:1': 'Pasar a 1:1',
  'Has hosted rooms people came to': 'Ha creado salas a las que la gente ha venido',
  'Has not said anything yet': 'Todavía no ha dicho nada',
  'Have a code?': '¿Tienes un código?',
  'Hide this person: no video, audio, texts, or files from them, and they cannot ask you to go 1:1':
    'Ocultar a esta persona: sin vídeo, voz, mensajes ni archivos suyos, y no puede pedirte pasar a 1:1',
  'Hides it here for now. They are not told, and they can still be accepted later.':
    'Lo oculta aquí por ahora. No se le avisa, y aún puedes aceptarlo más tarde.',
  Ignore: 'Ignorar',
  'Invite a regular...': 'Invitar a un habitual...',
  'Invite someone in': 'Invitar a alguien',
  Join: 'Entrar',
  'Join as Lumi Staff: you will be visible to the room, wearing the staff badge':
    'Entrar como Equipo de Lumi: serás visible para la sala, con la insignia del equipo',
  'Jump in': 'Únete',
  Kick: 'Expulsar',
  Leave: 'Salir',
  'Leave and block': 'Salir y bloquear',
  'Leave, and block the host: you stop being regulars and they cannot invite you again. They are not told.':
    'Salir y bloquear al anfitrión: dejáis de ser habituales y no puede volver a invitarte. No se le avisa.',
  'Loading...': 'Cargando...',
  'Lumi keeps the name, the code, who is in, and the sessions. Not the conversation.':
    'Lumi guarda el nombre, el código, quién está dentro y las sesiones. La conversación no.',
  MOD: 'MOD',
  Members: 'Miembros',
  'Message the room...': 'Escribe a la sala...',
  Mute: 'Silenciar',
  'My community': 'Mi comunidad',
  'New messages': 'Mensajes nuevos',
  'No live rooms right now.': 'Ninguna sala activa ahora mismo.',
  'No public rooms right now': 'Ninguna sala pública ahora mismo',
  'No session planned.': 'Ninguna sesión prevista.',
  'Nobody owns these and they never close. Walk in, listen for a while, and say something when you feel like it.':
    'Estas no son de nadie y nunca cierran. Entra, escucha un rato y di algo cuando te apetezca.',
  'Nobody yet. Invite a regular, or share your Lumi Link.': 'Todavía nadie. Invita a un habitual o comparte tu Lumi Link.',
  Once: 'Una vez',
  Open: 'Abrir',
  'Out of the community: they cannot come back unless you invite them again':
    'Fuera de la comunidad: no puede volver a menos que la invites de nuevo',
  'Out of the room for 15 minutes; still a member': 'Fuera de la sala 15 minutos; sigue siendo miembro',
  PRO: 'PRO',
  'People on camera, out of the camera slots this room has':
    'Personas con la cámara abierta, de las plazas de cámara que tiene esta sala',
  'Pin this for everyone in the room': 'Fijar esto para toda la sala',
  Private: 'Privada',
  'Public rooms': 'Salas públicas',
  Refresh: 'Actualizar',
  Rename: 'Cambiar el nombre',
  'Room Pro: the larger room': 'Room Pro: la sala grande',
  'Room chat': 'Chat de la sala',
  'Room code': 'Código de la sala',
  'Room name': 'Nombre de la sala',
  'Room rules': 'Normas de la sala',
  'Rooms that are always open': 'Salas siempre abiertas',
  'Rooms people are hosting': 'Salas que la gente tiene abiertas',
  'Say hi, I have been lurking': 'Saluda, llevo un rato mirando',
  See: 'Ver',
  Send: 'Enviar',
  Sessions: 'Sesiones',
  'Share a file': 'Compartir un archivo',
  'Sit down to work with a shared timer:': 'Ponte a trabajar con un temporizador compartido:',
  'Something to do together': 'Algo que hacer juntos',
  Start: 'Empezar',
  'Start a chat once and Lumi will remember you on this device; then a community can too.':
    'Habla una vez y Lumi te recordará en este dispositivo; entonces una comunidad también podrá.',
  'Start a community': 'Crear una comunidad',
  'Start a room': 'Crear una sala',
  'Start my community': 'Crear mi comunidad',
  'Started this room': 'Creó esta sala',
  'Straight into one': 'Directo a una',
  'Suggest a name nobody is using': 'Sugerir un nombre que nadie esté usando',
  'Take the invitation back': 'Retirar la invitación',
  'Talk with a few people at once. Start your own, or drop into one that is already going.':
    'Habla con varias personas a la vez. Crea la tuya o entra en una que ya esté en marcha.',
  'Text room': 'Sala de texto',
  'The language this room is for': 'El idioma de esta sala',
  'They leave the room and cannot come back unless you invite them again':
    'Sale de la sala y no puede volver a menos que la invites de nuevo',
  'Times are in your clock. Members see it inside the room and get a reminder ten minutes before, if they are on Lumi then.':
    'Las horas son las de tu reloj. Los miembros la ven dentro de la sala y reciben un aviso diez minutos antes, si están en Lumi en ese momento.',
  'Try again': 'Intentar de nuevo',
  'Video room': 'Sala de vídeo',
  'Vote: go private': 'Votar: hacerla privada',
  Waiting: 'Esperando',
  'We will find a room of that kind with space in it.': 'Buscaremos una sala de ese tipo con sitio libre.',
  'What are you doing?': '¿Qué estáis haciendo?',
  'What is it? e.g. Film night': '¿Qué es? P. ej. Noche de cine',
  'Who is in this room': 'Quién está en esta sala',
  Withdraw: 'Retirar',
  Yes: 'Sí',
  'You can enter any room here, including private ones and the minors band.':
    'Aquí puedes entrar en cualquier sala, incluidas las privadas y la franja de menores.',
  'You can invite your regulars once you have some: wave after a chat, and if they wave back, they are here to pick.':
    'Podrás invitar a tus habituales cuando los tengas: saluda después de una conversación y, si te devuelven el saludo, aparecerán aquí para elegirlos.',
  'You muted this person': 'Has silenciado a esta persona',
  'Your community': 'Tu comunidad',
  'Your community code': 'El código de tu comunidad',
  'Your status': 'Tu estado',
  Yours: 'La tuya',
  'e.g. Late Night Lounge': 'p. ej. Salón de madrugada',
  'e.g. Tuesday book club': 'p. ej. Club de lectura del martes',

  // ---- Account, Plus, support, activities, media controls ----
  ' I have written it down or saved it': ' Lo he apuntado o guardado',
  '(no drawing arrived, so describe what you imagine)': '(no llegó ningún dibujo, describe lo que imagines)',
  '(nothing arrived in time)': '(no llegó nada a tiempo)',
  '+30s': '+30s',
  'A concern, a bug or a question. It goes straight to the Lumi team. Replies appear here; keep the page open.':
    'Una duda, un fallo o una pregunta. Va directo al equipo de Lumi. Las respuestas aparecen aquí; deja la página abierta.',
  'A plausible answer': 'Una respuesta creíble',
  'A regular is someone you have both waved at after a chat. Lumi keeps the two of you, the names you saw, the date, any messages you send each other for thirty days, and any private note you keep about them. Nothing else: no history, and never where anyone was.':
    'Un habitual es alguien a quien saludasteis los dos después de una conversación. Lumi guarda a los dos, los nombres que visteis, la fecha, los mensajes que os enviéis durante treinta días y cualquier nota privada que guardes sobre esa persona. Nada más: sin historial, y nunca dónde estuvo nadie.',
  'A reviewer would like a brief live camera check to confirm your age. Tap Start when you are ready: they can see and talk to you until the check is decided.':
    'Un revisor quiere una comprobación breve con la cámara para confirmar tu edad. Toca Empezar cuando estés listo: podrá verte y hablar contigo hasta que se decida.',
  'A sentence somebody could draw': 'Una frase que alguien pueda dibujar',
  'A short tone when someone joins a room, when a regular is around, when a call comes in, and when a message arrives while you are looking elsewhere.':
    'Un tono breve cuando alguien entra en una sala, cuando un habitual está conectado, cuando entra una llamada y cuando llega un mensaje mientras miras a otro sitio.',
  'Add to queue': 'Añadir a la cola',
  'Amount (USD)': 'Importe (USD)',
  'An account is optional. Lumi works without one. Signing in only remembers your name, your Plus membership, and anything you have unlocked.':
    'La cuenta es opcional. Lumi funciona sin ella. Iniciar sesión solo recuerda tu nombre, tu suscripción Plus y lo que hayas desbloqueado.',
  'Asking...': 'Preguntando...',
  Back: 'Atrás',
  'Back ten seconds, for everyone': 'Diez segundos atrás, para todos',
  'Back to Lumi': 'Volver a Lumi',
  'Back to sign in': 'Volver a iniciar sesión',
  'Back to start': 'Volver al principio',
  'Background blur': 'Desenfoque de fondo',
  Block: 'Bloquear',
  Call: 'Llamar',
  Cancel: 'Cancelar',
  'Chat text size': 'Tamaño del texto',
  'Chat with an Admin': 'Hablar con un administrador',
  Clear: 'Borrar',
  Continue: 'Continuar',
  'Continue without sound': 'Continuar sin sonido',
  Cool: 'Frío',
  Copy: 'Copiar',
  'Cosmetics shop': 'Tienda de cosméticos',
  'Create account': 'Crear cuenta',
  'Delete this message for everyone': 'Eliminar este mensaje para todos',
  'Delete this message for you': 'Eliminar este mensaje solo para ti',
  'Describe the drawing in a sentence': 'Describe el dibujo en una frase',
  'Dismiss this notice': 'Descartar este aviso',
  Donate: 'Donar',
  'Draw and guess': 'Dibuja y adivina',
  'Draw this': 'Dibuja esto',
  Dream: 'Sueño',
  'Each round one person sees the marker and gives one clue. Everyone else guesses where it sits.':
    'En cada ronda una persona ve la marca y da una pista. Los demás adivinan dónde está.',
  'Earlier messages': 'Mensajes anteriores',
  'Eighty seconds a drawing. Three points for the first right guess, then two, then one, and one to the drawer each time.':
    'Ochenta segundos por dibujo. Tres puntos al primer acierto, luego dos, luego uno, y uno para quien dibuja cada vez.',
  'End the shared video for everyone': 'Terminar el vídeo compartido para todos',
  'End this activity for everyone': 'Terminar esta actividad para todos',
  Eraser: 'Goma',
  'Everyone answers, out loud or in the chat. No vote on this one.':
    'Responde todo el mundo, en voz alta o en el chat. En esta no se vota.',
  'Everyone writes a sentence. Each is handed on to be drawn, then described, then drawn again, round the table. Then the album.':
    'Cada uno escribe una frase. Se pasa para que la dibujen, luego la describan, luego la vuelvan a dibujar, dando la vuelta a la mesa. Después, el álbum.',
  FAQ: 'Preguntas frecuentes',
  Filter: 'Filtro',
  'Final scores': 'Puntuación final',
  'Forget me on this device': 'Olvídame en este dispositivo',
  'Forgot your password?': '¿Olvidaste tu contraseña?',
  From: 'De',
  'Get Lumi Plus': 'Consigue Lumi Plus',
  'Getting your camera ready...': 'Preparando tu cámara...',
  'Go Plus monthly': 'Plus mensual',
  'Go Plus yearly': 'Plus anual',
  'Handed in. Waiting for the others.': 'Entregado. Esperando a los demás.',
  'If you have lost the code as well, an admin can look at it.':
    'Si también has perdido el código, un administrador puede revisarlo.',
  'Insert an emoji': 'Insertar un emoji',
  Invisible: 'Invisible',
  'Join them': 'Únete',
  'Keep an independent, ad-free, privacy-first service alive. Thank you.':
    'Mantén vivo un servicio independiente, sin anuncios y que pone la privacidad primero. Gracias.',
  'Larger chat text': 'Texto más grande',
  'Line this up to play after what is on now': 'Ponlo en cola para después de lo que suena ahora',
  'Live check requested': 'Comprobación en directo solicitada',
  'Live: ten questions, fifteen seconds each. Fake answer: write something plausible, then vote; you score for finding the truth and for fooling people.':
    'En directo: diez preguntas, quince segundos cada una. Respuesta falsa: escribe algo creíble y luego vota; puntúas por encontrar la verdad y por engañar a los demás.',
  'Load and watch': 'Cargar y ver',
  'Lumi Plus and more': 'Lumi Plus y más',
  'Lumi admin': 'Administrador de Lumi',
  'Lumi is free and ad-free. Upgrades are optional and 18+ only. Under-18 accounts cannot be created.':
    'Lumi es gratis y sin anuncios. Las mejoras son opcionales y solo para mayores de 18. No se pueden crear cuentas de menores de 18.',
  'Lumi remembers you on this device with a random key, so rooms can find you again. It holds no name and no personal details, and it is deleted after 90 days away. Your regulars are kept with your account, not this device, so clearing it or being away does not lose them.':
    'Lumi te recuerda en este dispositivo con una clave aleatoria, para que las salas puedan encontrarte. No contiene ningún nombre ni dato personal, y se borra tras 90 días sin aparecer. Tus habituales se guardan con tu cuenta, no en este dispositivo, así que borrarlo o pasar tiempo sin venir no los pierde.',
  'Lumi remembers you on this device with a random key. Your regulars are tied to it: clear it, or stay away 90 days, and they are gone.':
    'Lumi te recuerda en este dispositivo con una clave aleatoria. Tus habituales van ligados a ella: si la borras, o pasas 90 días sin venir, se pierden.',
  'Make it sound true. Nobody sees who wrote what until the end.':
    'Haz que suene verdad. Nadie ve quién escribió qué hasta el final.',
  'Message deleted': 'Mensaje eliminado',
  'Message from the review team': 'Mensaje del equipo de revisión',
  'Messages here go only to Lumi administrators. A live voice/video chat starts only if you tap Start.':
    'Lo que escribas aquí va solo a los administradores de Lumi. La conversación de voz o vídeo empieza únicamente si tocas Empezar.',
  Mono: 'Mono',
  Monthly: 'Mensual',
  'More than half of the people here can skip what is on':
    'Más de la mitad de los presentes pueden saltar lo que está sonando',
  'New password (8+ characters)': 'Nueva contraseña (8+ caracteres)',
  'Nice!': '¡Bien!',
  'No answer.': 'Sin respuesta.',
  'No filter': 'Sin filtro',
  'No points yet.': 'Todavía sin puntos.',
  'No regulars yet.': 'Todavía sin habituales.',
  'No thanks': 'No, gracias',
  'Noise suppression': 'Supresión de ruido',
  'Not open yet': 'Todavía no está abierto',
  'Not open yet. ': 'Todavía no está abierto. ',
  'Nothing is remembered on this device yet.': 'Todavía no se recuerda nada en este dispositivo.',
  'One clue, a word or two': 'Una pista, una palabra o dos',
  'One of these is true. Which?': 'Una de estas es verdad. ¿Cuál?',
  'One person tells three things about themselves, two true and one made up. Everyone else votes for the lie.':
    'Una persona cuenta tres cosas sobre sí misma, dos verdad y una inventada. Los demás votan cuál es la mentira.',
  'Only you can see the marker. Say one thing that sits about here.':
    'Solo tú ves la marca. Di algo que esté más o menos aquí.',
  'Password (8+ characters)': 'Contraseña (8+ caracteres)',
  'Paste a link': 'Pega un enlace',
  'People you have both waved at after a chat. You stay anonymous to each other.':
    'Personas a las que os saludasteis los dos tras una conversación. Seguís siendo anónimos entre vosotros.',
  'Pick up': 'Contestar',
  'Plus is not on sale yet: these are the planned prices. Lumi is free and complete without it, and your account is ready for the day it opens.':
    'Plus todavía no está a la venta: estos son los precios previstos. Lumi es gratis y completo sin él, y tu cuenta estará lista el día que se abra.',
  Points: 'Puntos',
  'Priority matching, higher video quality, and exclusive cosmetics are now yours. Enjoy!':
    'Emparejamiento prioritario, mejor calidad de vídeo y cosméticos exclusivos ya son tuyos. ¡Disfrútalo!',
  'Priority queue, a higher video bitrate, cosmetic flair, and a Plus mark. No ads, no data sale, ever.':
    'Cola prioritaria, mayor calidad de vídeo, detalles cosméticos y la marca Plus. Sin anuncios y sin vender datos, nunca.',
  'Question cards': 'Cartas de preguntas',
  'Quiet hours': 'Horas de silencio',
  React: 'Reaccionar',
  'React to this message': 'Reacciona a este mensaje',
  Ready: 'Listo',
  'Recovery code from signup': 'Código de recuperación del registro',
  'Remove them from your regulars. They are not told.':
    'Quítalo de tus habituales. No se le avisa.',
  Reply: 'Responder',
  'Reply to this message': 'Responder a este mensaje',
  'Report this message to the Lumi team': 'Denunciar este mensaje al equipo de Lumi',
  'Report to an admin': 'Denunciar a un administrador',
  'Ringing...': 'Llamando...',
  'Room Pro': 'Room Pro',
  Scores: 'Puntuaciones',
  'Send to an admin': 'Enviar a un administrador',
  'Set a new password': 'Establecer una contraseña nueva',
  Settings: 'Ajustes',
  'Sign in': 'Iniciar sesión',
  'Sign in or create an account (18+) to go Plus, upgrade a room, or grab cosmetics. Lumi stays free either way.':
    'Inicia sesión o crea una cuenta (+18) para pasarte a Plus, mejorar una sala o conseguir cosméticos. Lumi sigue siendo gratis igualmente.',
  'Sign out': 'Cerrar sesión',
  'Signing in is instant. Creating an account is 18+ and includes a quick age check.':
    'Iniciar sesión es inmediato. Crear una cuenta es solo para mayores de 18 e incluye una comprobación rápida de edad.',
  'Skip forward thirty seconds, for everyone': 'Treinta segundos adelante, para todos',
  'Smaller chat text': 'Texto más pequeño',
  'Something drawable: one or two things, one action, one twist.':
    'Algo dibujable: una o dos cosas, una acción y un giro.',
  Sounds: 'Sonidos',
  Spectrum: 'Espectro',
  'Start live chat': 'Empezar la conversación en directo',
  'Start live check': 'Empezar la comprobación en directo',
  Stop: 'Parar',
  'Support Lumi': 'Apoya a Lumi',
  Telephone: 'Teléfono',
  Text: 'Texto',
  'The admin wants to talk live': 'El administrador quiere hablar en directo',
  'The code you were given when you created the account.':
    'El código que se te dio al crear la cuenta.',
  'The game is under way.': 'La partida está en marcha.',
  'The word was': 'La palabra era',
  'They are not free right now.': 'Ahora mismo no está libre.',
  'They did not pick up.': 'No ha contestado.',
  'This device': 'Este dispositivo',
  'This game runs inside a Lumi room.': 'Este juego se juega dentro de una sala de Lumi.',
  'This will not play here': 'Esto no se puede reproducir aquí',
  Trivia: 'Preguntas y respuestas',
  'Turn on camera': 'Encender la cámara',
  'Turn on microphone': 'Encender el micrófono',
  'Two ways to play': 'Dos formas de jugar',
  'Type a message...': 'Escribe un mensaje...',
  'Type your reply...': 'Escribe tu respuesta...',
  'Unpin it': 'Dejar de fijarlo',
  'Upgrade room': 'Mejorar la sala',
  'Use your recovery code': 'Usa tu código de recuperación',
  Username: 'Nombre de usuario',
  'Vanity code (e.g. LOUNGE)': 'Código personalizado (p. ej. SALON)',
  'Verifying your age': 'Verificando tu edad',
  Video: 'Vídeo',
  Voice: 'Voz',
  'Voice and video, so you can talk directly. Nothing starts until you tap.':
    'Voz y vídeo, para hablar directamente. No empieza nada hasta que toques.',
  'Waiting for the room...': 'Esperando a la sala...',
  Warm: 'Cálido',
  'What is this?': '¿Qué es esto?',
  'What would you like to tell us?': '¿Qué quieres contarnos?',
  'When a chat ends you can wave. If the other person waves too, within seven days, you become regulars: you see each other here, and which public room the other is in. Nobody is told about a wave that was not returned.':
    'Cuando termina una conversación puedes saludar. Si la otra persona saluda también, dentro de siete días, os convertís en habituales: os veis aquí y sabéis en qué sala pública está el otro. A nadie se le avisa de un saludo que no se devolvió.',
  'Whether everyone may play and pause. Seeking and stopping stay yours either way.':
    'Si todos pueden reproducir y pausar. Avanzar y detener siguen siendo cosa tuya en cualquier caso.',
  Whiteboard: 'Pizarra',
  'Who is playing': 'Quién juega',
  'Would you rather...': '¿Qué preferirías...?',
  'Write a message': 'Escribe un mensaje',
  'Write a sentence': 'Escribe una frase',
  'Write this down before you continue': 'Apunta esto antes de continuar',
  Yearly: 'Anual',
  'You are a Plus member. Thank you for keeping Lumi independent and ad-free.':
    'Eres miembro Plus. Gracias por mantener Lumi independiente y sin anuncios.',
  'You got it! Watch the others try.': '¡Acertaste! Mira cómo lo intentan los demás.',
  'You have been given Lumi Plus!': '¡Te han regalado Lumi Plus!',
  'You joined after it started, so you get to watch the album at the end.':
    'Entraste después de empezar, así que verás el álbum al final.',
  'Your Lumi account': 'Tu cuenta de Lumi',
  'Your answer is in.': 'Tu respuesta está registrada.',
  'Your guess': 'Tu respuesta',
  'Your microphone level (scaled by the volume slider)':
    'El nivel de tu micrófono (ajustado por el control de volumen)',
  'Your regulars will not see which room you are in, or that you are here at all.':
    'Tus habituales no verán en qué sala estás, ni siquiera que estás aquí.',
  'Your turn to draw. Pick a word:': 'Te toca dibujar. Elige una palabra:',
  'Your turn: give one clue': 'Te toca: da una pista',
  // A brand name: the same in every language. Listed so it reads as a
  // decision rather than a gap in the catalog.
  'Lumi Plus': 'Lumi Plus',
  'Audio': 'Voz',
  'Opens when we both agree': 'Se abre cuando los dos aceptamos',
  'Opens from the start': 'Se abre desde el principio',
  'Your account': 'Tu cuenta',
  'Sign in or create an account': 'Inicia sesión o crea una cuenta',
  'Create account (18+)': 'Crear cuenta (+18)',
  'Regulars ({n})': 'Habituales ({n})',
  'Still looking...': 'Seguimos buscando...',
  'Leave this tab open and go and do something else. You will hear a sound the moment someone arrives.': 'Deja esta pestaña abierta y ve a hacer otra cosa. Oirás un sonido en cuanto llegue alguien.',
  'Leave this tab open and go and do something else. The tab title will change the moment someone arrives.': 'Deja esta pestaña abierta y ve a hacer otra cosa. El título de la pestaña cambiará en cuanto llegue alguien.',
  'Or bring someone yourself! Post your Lumi Link to your social media and whoever opens it talks to you, not the queue.': '¡O trae a alguien tú! Publica tu Lumi Link en tus redes sociales y quien lo abra hablará contigo, no con la cola.',
  'It works while you are here, and for a day after. It only ever connects you to someone in your own age group.': 'Funciona mientras estés aquí, y durante un día más. Solo te conecta con alguien de tu misma franja de edad.',
  'Not sent. That is a Lumi Link, for bringing a friend from outside Lumi: send it to them in a text or a DM. The person here is already talking to you.': 'No enviado. Eso es un Lumi Link, para traer a un amigo desde fuera de Lumi: envíaselo por mensaje o por DM. La persona de aquí ya está hablando contigo.',
};
